/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useState } from 'react';
import { ModalHeader, ModalBody, Button } from '@nextui-org/react';
import { useSelector } from 'react-redux';
import { classNames, validateExcelFile } from '../../../utils';
import { IconDownload, IconUpload, IconFile, IconFileUpload } from '@tabler/icons-react';
import { UsersService } from '../../../services'
import { StudentsBulkUpload } from '../../../assets/files'
import toast from 'react-hot-toast';
import PaidAction from '../../../components/paid-action';

const STEP = {
  FORMAT: 1,
  UPLOAD: 2,
}

const ModalCreateStudentInBulk = ({ onSuccess }) => {
  const [step, setStep] = useState(STEP.FORMAT);
  const { fileInputRef, handleButtonClick, handleFileChange, isLoading, dowloadFile } = useFile();

  const nextStep = () => setStep(STEP.UPLOAD);

  const previousStep = () => setStep(STEP.FORMAT);

  const changeFile = async (e) => {
    const isSuccess = await handleFileChange(e);
    if (isSuccess) onSuccess();
  }


  return (
    <div>
      <ModalHeader className="flex flex-col gap-1">Carga masiva de estudiantes</ModalHeader>
      <ModalBody className="gap-8 min-h-40">
        <div className={`flex items-center justify-center gap-4 w-full `}>
          <div className='flex flex-col items-center'>
            <div className='w-14 h-14 p-3 rounded-full border-primary border flex justify-center items-center'>
              <IconFile className="w-full h-full object-cover text-primary" />
            </div>
            <p className='text-sm font-bold text-primary'>Planilla</p>
          </div>

          <div className='border border-gray w-20 mx-10'></div>

          <div className='flex flex-col items-center'>
            <div className={classNames(
              step === STEP.UPLOAD ? 'border-primary' : 'border-gray',
              'w-14 h-14 p-3 rounded-full border flex justify-center items-center'
            )}>
              <IconFileUpload className={classNames(
                step === STEP.UPLOAD ? 'text-primary' : 'text-gray',
                'w-full h-full object-cover'
              )} />
            </div>
            <p className={classNames(
              step === STEP.UPLOAD ? 'text-primary' : 'text-gray',
              'text-sm font-bold'
            )}>Subir</p>
          </div>
        </div>

        <div className='px-6 py-5'>
          {step === STEP.FORMAT ? (
            <div className='px-5'>
              <p className='font-bold text-secondary'>Paso 1</p>
              <p className='mb-10'>Descargar el archivo excel</p>
              <PaidAction>
                <Button
                  variant="solid"
                  className="bg-secondary text-white"
                  startContent={<IconDownload className="w-5 h-5" />}
                  onPress={dowloadFile}
                  isDisabled={isLoading}
                  isLoading={isLoading}
                >
                  Descargar archivo excel
                </Button>
              </PaidAction>

              <div className='w-full flex justify-center mt-40'>
                <Button
                  variant='solid'
                  className='bg-primary w-full text-white font-bold'
                  onPress={nextStep}
                  isDisabled={isLoading}
                >
                  Siguiente
                </Button>
              </div>
            </div>
          ) : (
            <>
              <div className='px-5'>
                <p className='font-bold text-secondary'>Paso 2</p>
                <p>Cargar la información de los estudiantes en el orden indicado en el Excel. Sin modificar celdas</p>
                <p className='font-bold text-secondary mt-4'>Paso 3</p>
                <p>Sube tu archivo Excel con la información completa de los estudiantes</p>
              </div>

              <div className='mt-4 px-6 py-4 bg-primary-50 border border-secondary rounded-md'>
                <p className='font-extrabold text-secondary'>Importante</p>
                <p className='font-bold'>Esta función permite actualizar la base de datos de registro de estudiantes</p>

                <p className='font-extrabold mt-2'>Usar esta función de actualización reemplaza la base de datos de estudiantes previamente cargada</p>
              </div>


              <div className='w-full flex items-center justify-center flex-col mt-4'>
                <Button
                  className='bg-success text-white w-full'
                  onPress={handleButtonClick}
                  startContent={<IconUpload className='w-5 h-5' />}
                  isLoading={isLoading}
                  isDisabled={isLoading}
                >
                  Subir formato de registro
                </Button>
                <Button variant='light' className='w-fit mt-2' onPress={previousStep}>Regresar</Button>
              </div>

              <input
                ref={fileInputRef}
                type="file"
                accept='.xlsx'
                className='hidden'
                onChange={changeFile}
              />
            </>
          )}
        </div>
      </ModalBody>
    </div>
  )
}

const useFile = () => {
  const [isLoading, setIsLoading] = useState(false);
  const user = useSelector(state => state.user);
  const fileInputRef = useRef(null);

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) {
      fileInputRef.current.value = '';
      return;
    }

    if (!validateExcelFile(file)) {
      toast.error('El archivo debe ser de formato xlsx');
      fileInputRef.current.value = '';
      return;
    }

    try {
      setIsLoading(true);
      const payload = {
        hasFile: true,
        school_id: user.id,
        file: file,
      };
      await UsersService.school.createStudentInBulk(payload);
      toast.success('El archivo se ha cargado correctamente');
      setIsLoading(false);
      return true

    } catch (error) {
      toast.error(String(error) || 'Ocurrió un error inesperado', { duration: 5000 });
      fileInputRef.current.value = '';
      setIsLoading(false);
      return false;
    }
  };


  const dowloadFile = async () => {
    setIsLoading(true);
    try {
      const blob = await UsersService.school.dowloadFile(StudentsBulkUpload);
      if (!blob) return;
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = 'registro-estudiantes.xlsx';
      link.click();
    } catch (error) {
      toast.error(String(error) || 'Ocurrió un error inesperado', { duration: 5000 });
    } finally {
      setIsLoading(false);
    }
  }



  return {
    fileInputRef,
    handleButtonClick,
    handleFileChange,
    isLoading,
    dowloadFile,
  }
}


export default ModalCreateStudentInBulk;
